import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TopNavbarRoutingModule } from './top-navbar-routing.module';
import { MaterialModule } from '../shared/material/material.module';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    TopNavbarRoutingModule
  ]
})
export class TopNavbarModule { }
